/**
 *
 * SetupLoader
 *
 */
// import { Spinner } from 'core/components/Spinner';
import StyleComponentProps from 'core/utils/types/StyleComponentProps';
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import loader from 'assets/images/loader.webp';

interface Props extends StyleComponentProps {
  size?: string;
}

export const SetupLoader = memo((props: Props) => {
  return (
    <Div
      className={`w-full ${props?.height || "h-full"} flex justify-center items-center ${props.className}`}
    >
      {/* <Spinner width={props.size || '5vw'} /> */}
      <img src={loader} alt="loader" className={`rounded-lg ${props?.height || "h-[16vh]"}`} />
      {/* <div className={}>
      </div> */}
    </Div>
  );
});

const Div = styled.div``;
